import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import Callback from './pages/Callback';
import Preview from './pages/Preview';

function RequireSession({ children }) {
  const { loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <p className="status" role="status">
        Checking your session…
      </p>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/login/callback" element={<Callback />} />
      <Route path="/preview" element={<Preview />} />
      <Route
        path="/"
        element={
          <RequireSession>
            <Home />
          </RequireSession>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
